// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Modal, // eslint-disable-line no-unused-vars
  ModalHeader, // eslint-disable-line no-unused-vars
  ModalBody, // eslint-disable-line no-unused-vars
  Heading, // eslint-disable-line no-unused-vars
  Tag, // eslint-disable-line no-unused-vars
  IconHelp, // eslint-disable-line no-unused-vars
  dlsBrightBlue,
  ButtonTertiary, // eslint-disable-line no-unused-vars
  OverflowMenu, // eslint-disable-line no-unused-vars
} from '@americanexpress/dls-react';
import helpMenuStyles from '../../styles/helpMenuStyles';
import labels from '../../constants/labels';

const HelpMenu = () => {
  const loginData = useSelector((state) => state.getIn(['modules', 'axp-secure-file-express-root', 'userData', 'login'])
  );
  const pageInstructions = useSelector((state) => state.getIn(['modules', 'axp-secure-file-express-root', 'helpMenuData', 'pageInstructions'])
  );

  const moreInstructions = useSelector((state) => state.getIn(['modules', 'axp-secure-file-express-root', 'helpMenuData', 'moreInstructions'])
  );

  const overflowLabel = (
    <ButtonTertiary className="hidden-sm-down" id="help-btn" size="sm">
      {labels.HELP}
    </ButtonTertiary>
  );

  const onToggleClose = (event) => {
    // simulate Escape event onClick of Modal Close Icon to close the Modal
    if (event && event.currentTarget?.id === 'help-modal-close-Btn') {
      const evt = new KeyboardEvent('keydown', { key: 'Esc' });
      window.dispatchEvent(evt);
    }
  };

  return (
    <OverflowMenu
      id="help-overflow-menu"
      data-testid="help-overflow-btn"
      theme={helpMenuStyles.overflowLabelOverrideStyle}
      align="right"
      label={overflowLabel}
      aria-live="polite"
      className="display-inline"
    >
      <Modal data-testid="help-modal" onClose={onToggleClose} theme={helpMenuStyles.modalStyle}>
        <ModalHeader
          theme={{ backgroundColor: '#ECEDEE' }}
          closeButtonProps={{ id: 'help-modal-close-Btn', dataTestid: 'help-modal-close-Btn', className: 'dls-bright-blue' }}
        >
          <div className="flex flex-align-center flex-justify-center margin-auto">
            <IconHelp size="sm" theme={dlsBrightBlue} title="help icon" />
            <h2 className="fluid heading-3 dls-bright-blue pad-1-l">Help Center</h2>
          </div>
        </ModalHeader>

        <ModalBody theme={helpMenuStyles.modalBodyStyle}>
          <div className="pad pad-1-tb">
            <Heading level={1} headingStyle="heading4" className="pad-1-b">
              Hello {`${loginData.userDetail?.userFirstName || 'NA'}`}
            </Heading>
            <p className="body-1">This is your personalised help assistant. Select from the below options. </p>
          </div>
          <hr />
          {pageInstructions.length > 0 && (
            <LinkInstructions
              data-testid="page-instructions"
              heading="Instruction for this page"
              instructionsData={pageInstructions}
            />
          )}
          {moreInstructions.length > 0 && (
            <TagInstructions data-testid="more-instructions" heading="More" instructionsData={moreInstructions} />
          )}
        </ModalBody>
      </Modal>
    </OverflowMenu>
  );
};

export default HelpMenu;

HelpMenu.propTypes = {};

const LinkInstructions = ({ heading, instructionsData, ...otherProps }) => (
  <>
    <div className="pad pad-1-tb" {...otherProps}>
      <Heading level={3} headingStyle="heading3" className="pad-1-b">
        {heading}
      </Heading>
      <div className="flex flex-column">
        {instructionsData.map((instruction) => (
          <Heading
            key={instruction.instructionId}
            level={1}
            headingStyle="heading3"
            style={{ color: '#006fcf' }}
          > Coming soon....
          </Heading>
        ))}

      </div>

    </div>
    <hr />
  </>
);
LinkInstructions.propTypes = {
  heading: PropTypes.string.isRequired,
  instructionsData: PropTypes.arrayOf(
    PropTypes.shape({
      instructionId: PropTypes.string.isRequired,
      instructionName: PropTypes.string.isRequired,
      instructionLink: PropTypes.string.isRequired,
    })
  ),
};

const TagInstructions = ({ heading, instructionsData, ...otherProps }) => {
/**
     * Opens a new window with the specified URL.
     * @param {string} pathname - The URL to open in a new window.
     */
     const onTagBtnClick = (pathname) => {
     window.open(pathname, '_blank');
  };

  return (
    <div className="pad pad-1-tb" {...otherProps}>
      <Heading level={3} headingStyle="heading3" className="pad-1-b">
        {heading}
      </Heading>
      <div className="stack-1">
        {instructionsData.map((instruction) => (
          <Tag
            id={instruction.instructionId}
            key={instruction.instructionId}
            role="button"
            onClick={() => onTagBtnClick(instruction.instructionLink)}
          >
            {instruction.instructionName}
          </Tag>
        ))}
      </div>
    </div>
  );
};
TagInstructions.propTypes = {
  heading: PropTypes.string.isRequired,
  instructionsData: PropTypes.arrayOf(
    PropTypes.shape({
      instructionId: PropTypes.string.isRequired,
      instructionName: PropTypes.string.isRequired,
      instructionLink: PropTypes.string.isRequired,
    })
  ),
};
